import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Image from '../../../../Core/Image';

export const Card = styled.div`
  display: grid;
  grid-template-rows: subgrid;
  grid-row: auto / span 2;
  row-gap: 0;
  border-radius: 0.625rem 0.625rem 0rem 0rem;
  overflow: hidden;
  border-top: 5px solid
    ${({ $borderColor }) =>
      $borderColor ? themeGet(`colors.${$borderColor}`) : 'transparent'};
  background: ${({ $backgroundColor }) =>
    $backgroundColor ? themeGet(`colors.${$backgroundColor}`) : 'transparent'};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  border-left: 1px solid ${themeGet('colors.pc-lilac')};
  border-right: 1px solid ${themeGet('colors.pc-lilac')};
  padding: 1.5rem 2.25rem;
  align-items: center;
  p {
    font-size: 1.25rem;
  }
`;

export const Body = styled.div`
  border: 1px solid ${themeGet('colors.pc-lilac')};
  padding: 1.5rem 2.5rem 3.5rem;
`;

export const Icon = styled(Image)`
  width: 2.5rem;
  height: 2.5rem;
  margin-right: 1rem;
`;
